import React from 'react'
import PropTypes from 'prop-types'

const Version = ({ className }) => {
  if (!process.env.REACT_APP_VERSION) return null

  return (
    <span className={className} id="version">
      {process.env.REACT_APP_VERSION ?? ''}
    </span>
  )
}

Version.defaultProps = {
  className: '',
}

Version.propTypes = {
  className: PropTypes.string,
}

export default Version
